import apiCall from '../../index'

const apiService = '/api-erppalmas/api/v1/catalogos/ubigeo'

const service = {
  findAll(params) {
    const query = `?codUbigeo=${params.codUbigeo}&get=${params.get}`
    return new Promise((resolve, reject) => {
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
